<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        <h3>編輯聯絡人資料</h3>
      </v-card-title>
      <!--  -->
      <v-card-text>
        <v-form v-model="dialogInputValid" @submit.prevent="">
          <v-row>
            <v-col>
              <v-text-field
                v-model="contactName"
                label="姓名"
                :rules="dialogInputRules"
                :counter="10"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="contactPhone"
                label="電話"
                :rules="phoneRules"
                :counter="18"
                @keydown.space.prevent=""
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="contactLine"
                label="LineID"
                :counter="32"
                @keydown.space.prevent=""
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="contactMaterial"
                label="匯款資料"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea v-model="contactMemo" label="備註"></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <!--  -->
      <v-card-actions>
        <v-row>
          <v-col>
            <v-btn elevation="4" color="error" @click="dialog = false">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-col>
          <v-col class="text-end">
            <v-btn
              elevation="4"
              color="success"
              @click="handleOnDialogSave"
              :disabled="isSending"
            >
              <v-icon>mdi-check-bold</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <!--  -->
      <v-progress-linear
        :active="isSending"
        indeterminate
        absolute
        bottom
      ></v-progress-linear>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: ['dialogContact', 'content'],
  data() {
    return {
      //
      dialog: false,
      //
      agentId: '',
      memberId: '',
      //
      contactId: '',
      contactName: '',
      contactPhone: '',
      contactLine: '',
      contactMaterial: '',
      contactMemo: '',
      //
      dialogInputValid: false,
      dialogInputRules: [
        v => !!v || '不可空白',
        v => v.length <= 10 || '不可超過10個字'
      ],
      phoneRules: [
        v => !!v || '不可空白',
        v => Number.isInteger(Number(v)) || '必須是數字',
        v => v.length === 10 || '字數錯誤'
      ]
    }
  },
  watch: {
    dialogContact() {
      this.agentId = this.content.agent_id || ''
      this.memberId = this.content.member_id || ''
      //
      this.contactId = this.content.contact_id || ''
      this.contactName = this.content.name || ''
      this.contactPhone = this.content.phone || ''
      this.contactLine = this.content.line || ''
      this.contactMaterial = this.content.material || ''
      this.contactMemo = this.content.memo || ''
      this.dialog = true
    }
  },
  computed: {
    ...mapState('account', ['uid', 'user', 'level']),
    ...mapState('admin', ['isSending'])
  },
  methods: {
    ...mapActions('admin', ['updateAgentContact', 'updateMemberContact']),
    async handleOnDialogSave() {
      if (!this.contactName || !this.contactPhone) return
      if (!this.dialogInputValid) return
      const { agentId, memberId, level, user, uid } = this
      const path = window.location.pathname
      if (path === '/agent') {
        await this.updateAgentContact({
          agentId,
          c_id: this.contactId,
          name: this.contactName,
          phone: this.contactPhone,
          line: this.contactLine,
          material: this.contactMaterial,
          memo: this.contactMemo,
          user,
          uid
        })
      } else {
        await this.updateMemberContact({
          memberId,
          level,
          c_id: this.contactId,
          name: this.contactName,
          phone: this.contactPhone,
          line: this.contactLine,
          material: this.contactMaterial,
          memo: this.contactMemo,
          user,
          uid
        })
      }
      this.dialog = false
    }
  }
}
</script>

<style></style>
